webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONNECTION_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_USER_AVATAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_VEHICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VIDEO_TIME_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return VIDEO_SEEK_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_TRACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_TRACK_POINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_TRACK_CURRENT_IDX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_TRACK_DISTANCES; });
var CONNECTION_CONFIG = 'CONNECTION_CONFIG';
var SET_USER = 'SET_USER';
var SET_USER_AVATAR = 'SET_USER_AVATAR';
var SET_VEHICLE = 'SET_VEHICLE';
var SET_VIDEO = 'SET_VIDEO';
var VIDEO_TIME_UPDATE = 'VIDEO_TIME_UPDATE';
var VIDEO_SEEK_TO = 'VIDEO_SEEK_TO';
var SET_TRACK = 'SET_TRACK';
var SET_TRACK_POINTS = 'SET_TRACK_POINTS';
var SET_TRACK_CURRENT_IDX = 'SET_TRACK_CURRENT_IDX';
var SET_TRACK_DISTANCES = 'SET_TRACK_DISTANCES';

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(197),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__effects__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins__ = __webpack_require__(88);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';
var logger = false; // enable logger explicitly if needed for as it hurts performance

var plugins = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__plugins__["a" /* createSideEffects */])(__WEBPACK_IMPORTED_MODULE_6__effects__["a" /* default */])];
debug && logger && plugins.push(__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default()());

var state = {
  jwt: null,
  id: null,
  unit: 'km',
  lang: 'en',
  user: {},
  vehicle: {},
  video: {},
  track: {}
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* default */],
  strict: debug,
  plugins: plugins
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(200),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CDN_URL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jwt_decode__);



var API_URLS = {
  dev: "https://dev.motocompano.com/api",
  live: "https://mb.motocompano.com/api",
  beta: "https://beta.motocompano.com/api"
};

var CDN_URL = "https://cdn.motocompano.com";

var TOKEN_HEADER_KEY = 'x-authorization';

var api = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();

function setup(jwt) {
  try {
    var _decode = __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(jwt),
        sys = _decode.sys,
        version = _decode.api;

    api.defaults.baseURL = API_URLS[sys];
    api.defaults.headers['Accept'] = api.defaults.headers.common['Accept'] + ', application/vnd.motocompano.api+json;version=' + (version || 7);
    api.defaults.headers[TOKEN_HEADER_KEY] = jwt;
    return true;
  } catch (e) {
    return false;
  }
}

var getInfo = function getInfo(id) {
  return api.get('/info?id=' + id + '&type=videotrack');
};
var getUser = function getUser(id) {
  return api.get('/users/index?user=' + id);
};
var getGraph = function getGraph(url) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setup: setup,
  getInfo: getInfo,
  getUser: getUser,
  getGraph: getGraph
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ress_ress_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ress_ress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ress_ress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet_dist_leaflet_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet_dist_leaflet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_leaflet_dist_leaflet_css__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App___default.a);
  },
  store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configureConnectionFromParams", function() { return configureConnectionFromParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInfo", function() { return fetchInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchGraph", function() { return fetchGraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "percentToTrackIdx", function() { return percentToTrackIdx; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(13);





var configureConnectionFromParams = function configureConnectionFromParams(_ref) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var jwt = getParam('jwt');
    var id = getParam('id');
    var unit = getParam('unit');
    var lang = getParam('lang');
    if (jwt && id) {
      if (__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].setup(jwt)) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* CONNECTION_CONFIG */], { jwt: jwt, id: id, unit: unit, lang: lang });
        resolve();
      } else {
        reject('invalid jwt');
      }
    } else {
      reject('no jwt and videotrack id specified');
    }
  });
};

var fetchInfo = function fetchInfo(_ref2) {
  var commit = _ref2.commit,
      state = _ref2.state;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getInfo(state.id).then(function (response) {
      var data = extractData(response.data.data);
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* SET_USER */], data);
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* SET_VEHICLE */], data);
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* SET_VIDEO */], data);
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* SET_TRACK */], data);
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getUser(state.user.id).then(function (response) {
        var image = response.data.data.image;

        if (image) {
          var avatar = __WEBPACK_IMPORTED_MODULE_2__api__["b" /* CDN_URL */] + '/preview/image/' + idToPathPart(image);
          commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_USER_AVATAR */], avatar);
        }
      });
      resolve();
    }).catch(function (error) {
      console.log(error);
      reject();
    });
  });
};

var fetchGraph = function fetchGraph(_ref3) {
  var commit = _ref3.commit,
      state = _ref3.state;

  __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getGraph(state.track.url).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* SET_TRACK_POINTS */], { points: response.data });
  });
};

var percentToTrackIdx = function percentToTrackIdx(_ref4, percent) {
  var commit = _ref4.commit,
      state = _ref4.state;

  var idx = Math.round(percent * (state.track.points.length - 1) / 100);
  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* SET_TRACK_CURRENT_IDX */], { idx: idx });
};

function extractData(data) {
  return {
    user: extractUser(data),
    vehicle: extractVehicle(data),
    track: extractTrack(data),
    video: extractVideo(data)
  };
}

function extractUser(_ref5) {
  var id = _ref5.user_id,
      name = _ref5.user_reference.user_name;

  return {
    id: id,
    name: name,
    avatar: null
    // avatar: 'https://robohash.org/robo' + id + '?size=40x40&set=set1'
  };
}

function extractVehicle(data) {
  var _data$vehicle_referen = data.vehicle_reference,
      name = _data$vehicle_referen.vehicle_name,
      brand = _data$vehicle_referen.brand,
      model = _data$vehicle_referen.model,
      avatar = _data$vehicle_referen.avatar;

  return {
    name: name,
    brand: brand,
    model: model,
    avatar: avatar && __WEBPACK_IMPORTED_MODULE_2__api__["b" /* CDN_URL */] + '/preview/image/' + idToPathPart(avatar)
    // avatar: 'https://robohash.org/robo' + id + '?size=40x40&set=set3'
  };
}

function extractTrack(_ref6) {
  var id = _ref6.data_name,
      color = _ref6.color;

  return {
    url: __WEBPACK_IMPORTED_MODULE_2__api__["b" /* CDN_URL */] + '/data/track/' + idToPathPart(id) + '.graph.json',
    id: id,
    color: color
  };
}

function extractVideo(_ref7) {
  var _ref7$objects$video = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref7.objects.video, 1),
      id = _ref7$objects$video[0];

  return {
    url: __WEBPACK_IMPORTED_MODULE_2__api__["b" /* CDN_URL */] + '/data/video/' + idToPathPart(id) + '_s.mp4',
    id: id
  };
}

function idToPathPart(id) {
  var parts = id.toString().split('-');
  return parts[1] ? parts[0].substring(0, 2) + '/' + parts[1].substring(0, 2) + '/' + id : id;
}

function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(13);


var _VIDEO_TIME_UPDATE$SE;





/* harmony default export */ __webpack_exports__["a"] = (_VIDEO_TIME_UPDATE$SE = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_VIDEO_TIME_UPDATE$SE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* VIDEO_TIME_UPDATE */], function (store, _ref, state) {
  var payload = _ref.payload;

  if (state.track.points) {
    var millis = Math.round(payload * 1000);
    var idx = Math.round(millis / state.track.interval);
    var lastIdx = state.track.points.length - 1;
    idx = idx < lastIdx ? idx : lastIdx;
    if (idx !== state.track.current_idx) {
      store.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* SET_TRACK_CURRENT_IDX */], { idx: idx, skipSync: true });
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_VIDEO_TIME_UPDATE$SE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* SET_TRACK_CURRENT_IDX */], function (store, _ref2, state) {
  var _ref2$payload = _ref2.payload,
      idx = _ref2$payload.idx,
      skipSync = _ref2$payload.skipSync;

  var point = state.track.points[idx];
  if (point && !skipSync) {
    store.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* VIDEO_SEEK_TO */], point.dur / 1000);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_VIDEO_TIME_UPDATE$SE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* SET_TRACK_POINTS */], function (store, mutation, state) {
  var distances = state.track.points.reduce(function (m, v) {
    var previous = m.pop();
    if (previous) {
      var meters = new __WEBPACK_IMPORTED_MODULE_1_leaflet__["LatLng"](v.lat, v.lng).distanceTo(previous);
      m.push(m[m.length - 1] + Math.round(meters));
    } else {
      m.push(0);
    }
    m.push([v.lat, v.lng]);
    return m;
  }, []);
  distances.pop();
  store.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* SET_TRACK_DISTANCES */], distances);
}), _VIDEO_TIME_UPDATE$SE);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chartSeries", function() { return chartSeries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentPoint", function() { return currentPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentDistance", function() { return currentDistance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentReadout", function() { return currentReadout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentPercent", function() { return currentPercent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_chart_data__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_pipe__ = __webpack_require__(92);



var series = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_pipe__["a" /* pipe */])(__WEBPACK_IMPORTED_MODULE_0__utils_chart_data__["a" /* getSeries */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_chart_data__["b" /* downsampleSeriesBy */])('speed'), __WEBPACK_IMPORTED_MODULE_0__utils_chart_data__["c" /* normalizeSeries */]);

var chartSeries = function chartSeries(state) {
  if (state.track.points) {
    return series(state.track.points);
  }
};

var currentPoint = function currentPoint(state) {
  return state.track.points && state.track.points[state.track.current_idx] || {};
};

var currentDistance = function currentDistance(state) {
  return state.track.distances && state.track.distances[state.track.current_idx];
};

var currentReadout = function currentReadout(state, getters) {
  var point = getters.currentPoint;
  return {
    speed: point.v_kmh,
    elevation: point.ele,
    distance: getters.currentDistance
  };
};

var currentPercent = function currentPercent(state) {
  return state.track.points && state.track.current_idx * 100 / (state.track.points.length - 1);
};

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(13);



var _types$CONNECTION_CON;



/* harmony default export */ __webpack_exports__["a"] = (_types$CONNECTION_CON = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CONNECTION_CON, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* CONNECTION_CONFIG */], function (state, _ref) {
  var jwt = _ref.jwt,
      id = _ref.id,
      unit = _ref.unit,
      lang = _ref.lang;

  state.jwt = jwt;
  state.id = id;
  state.unit = unit;
  state.lang = lang;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CONNECTION_CON, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SET_USER */], function (state, _ref2) {
  var user = _ref2.user;

  state.user = user;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CONNECTION_CON, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_USER_AVATAR */], function (state, avatar) {
  state.user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.user, { avatar: avatar });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CONNECTION_CON, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_VEHICLE */], function (state, _ref3) {
  var vehicle = _ref3.vehicle;

  state.vehicle = vehicle;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CONNECTION_CON, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SET_VIDEO */], function (state, _ref4) {
  var video = _ref4.video;

  state.video = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, video, { current_time: 0, seek_time: 0 });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CONNECTION_CON, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* VIDEO_TIME_UPDATE */], function (state, seconds) {
  state.video.current_time = seconds;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CONNECTION_CON, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* VIDEO_SEEK_TO */], function (state, seconds) {
  state.video.seek_time = seconds;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CONNECTION_CON, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* SET_TRACK */], function (state, _ref5) {
  var track = _ref5.track;

  state.track = track;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CONNECTION_CON, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* SET_TRACK_POINTS */], function (state, _ref6) {
  var points = _ref6.points;

  state.track = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.track, {
    points: points,
    current_idx: 0,
    interval: points[1].dur - points[0].dur
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CONNECTION_CON, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* SET_TRACK_CURRENT_IDX */], function (state, _ref7) {
  var idx = _ref7.idx;

  state.track.current_idx = idx;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CONNECTION_CON, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* SET_TRACK_DISTANCES */], function (state, distances) {
  state.track = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.track, { distances: distances });
}), _types$CONNECTION_CON);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSideEffects; });
var createSideEffects = function createSideEffects(effects) {
  return function (store) {
    store.subscribe(function (mutation, state) {
      (effects[mutation.type] || noop)(store, mutation, state);
    });
  };
};

function noop() {}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSeries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return normalizeSeries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return downsampleSeriesBy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


var CHART_SIZE = 800;

var getSeries = function getSeries(points) {
  return points.reduce(function (series, _ref) {
    var v_kmh = _ref.v_kmh,
        ele = _ref.ele;

    series.speed.push(v_kmh);
    series.elevation.push(ele);
    return series;
  }, { speed: [], elevation: [] });
};

var normalizeSeries = function normalizeSeries(_ref2) {
  var speed = _ref2.speed,
      elevation = _ref2.elevation;

  return {
    speed: normalizeTo100(speed),
    elevation: normalizeTo100(elevation)
  };
};

var downsampleSeriesBy = function downsampleSeriesBy(base) {
  return function (series) {
    var downsampledSeries = { speed: [], elevation: [] };
    var others = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(downsampledSeries).filter(function (el) {
      return el !== base;
    });
    var factor = calcDecreaseFactor(series[base].length, CHART_SIZE);

    return downsample(series[base], factor).reduce(function (m, v) {
      m[base].push(v[1]);
      others.forEach(function (other) {
        m[other].push(series[other][v[0]]);
      });
      return m;
    }, downsampledSeries);
  };
};

function normalizeTo100(numbers) {
  var min = Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(numbers));
  var hundred = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(numbers)) - min;

  return hundred === 0 ? numbers : numbers.reduce(function (m, v) {
    var rel = 100 * (v - min) / hundred;
    m.push(rel);
    return m;
  }, []);
}

function calcDecreaseFactor(size, desiredSize) {
  return size > desiredSize ? round(desiredSize / size, 6) : 1;
}

function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

function downsample(array, decreaseFactor) {
  var data = array.map(function (v, idx) {
    return [idx, v];
  });
  var threshold = Math.round(data.length * (decreaseFactor || 0.7));
  return largestTriangleThreeBuckets(data, threshold);
}

/*
 * Downsampling formula taken from
 * https://github.com/sveinn-steinarsson/flot-downsample/blob/master/jquery.flot.downsample.js
 */

/* eslint-disable */
function largestTriangleThreeBuckets(data, threshold) {
  var floor = Math.floor,
      abs = Math.abs;

  var data_length = data.length;
  if (threshold >= data_length || threshold === 0) {
    return data; // Nothing to do
  }

  var sampled = [],
      sampled_index = 0;

  // Bucket size. Leave room for start and end data points
  var every = (data_length - 2) / (threshold - 2);

  var a = 0,
      // Initially a is the first point in the triangle
  max_area_point,
      max_area,
      area,
      next_a;

  sampled[sampled_index++] = data[a]; // Always add the first point

  for (var i = 0; i < threshold - 2; i++) {

    // Calculate point average for next bucket (containing c)
    var avg_x = 0,
        avg_y = 0,
        avg_range_start = floor((i + 1) * every) + 1,
        avg_range_end = floor((i + 2) * every) + 1;
    avg_range_end = avg_range_end < data_length ? avg_range_end : data_length;

    var avg_range_length = avg_range_end - avg_range_start;

    for (; avg_range_start < avg_range_end; avg_range_start++) {
      avg_x += data[avg_range_start][0] * 1; // * 1 enforces Number (value may be Date)
      avg_y += data[avg_range_start][1] * 1;
    }
    avg_x /= avg_range_length;
    avg_y /= avg_range_length;

    // Get the range for this bucket
    var range_offs = floor((i + 0) * every) + 1,
        range_to = floor((i + 1) * every) + 1;

    // Point a
    var point_a_x = data[a][0] * 1,
        // enforce Number (value may be Date)
    point_a_y = data[a][1] * 1;

    max_area = area = -1;

    for (; range_offs < range_to; range_offs++) {
      // Calculate triangle area over three buckets
      area = abs((point_a_x - avg_x) * (data[range_offs][1] - point_a_y) - (point_a_x - data[range_offs][0]) * (avg_y - point_a_y)) * 0.5;
      if (area > max_area) {
        max_area = area;
        max_area_point = data[range_offs];
        next_a = range_offs; // Next a is this b
      }
    }

    sampled[sampled_index++] = max_area_point; // Pick this point from the bucket
    a = next_a; // This a is the next a (chosen b)
  }

  sampled[sampled_index++] = data[data_length - 1]; // Always add last

  return sampled;
}
/* eslint-enable */

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isIOSDevice; });
var isIOSDevice = function isIOSDevice() {
  return navigator.userAgent.match(/ip(hone|ad|od)/i) && !navigator.userAgent.match(/(iemobile)[/\s]?([\w.]*)/i);
};

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export msToTime */
function msToTime(duration) {
  var round = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  duration = Math.round(duration);
  var ms = duration % 1000;
  duration = (duration - ms) / 1000;
  var secs = duration % 60;
  duration = (duration - secs) / 60;
  var mins = duration % 60;
  var hrs = (duration - mins) / 60;
  return pad(hrs, 2) + ':' + pad(mins, 2) + ':' + (round ? pad(secs + Math.round(ms / 1000), 2) : pad(secs, 2) + '.' + pad(ms, 3));
}

function pad(n, z) {
  z = z || 2;
  return ('00' + n).slice(-z);
}

// mixin
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    msToTime: msToTime
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pipe; });
var _pipe = function _pipe(f, g) {
  return function () {
    return g(f.apply(undefined, arguments));
  };
};
var pipe = function pipe() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return fns.reduce(_pipe);
};

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ProfileOverview__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ProfileOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ProfileOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_player_Player__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_player_Player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_player_Player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ChartGuide__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ChartGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ChartGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Chart__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Readouts__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Readouts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Readouts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LeafletMap__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LeafletMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_LeafletMap__);
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    ProfileOverview: __WEBPACK_IMPORTED_MODULE_0__components_ProfileOverview___default.a,
    Player: __WEBPACK_IMPORTED_MODULE_1__components_player_Player___default.a,
    ChartGuide: __WEBPACK_IMPORTED_MODULE_2__components_ChartGuide___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3__components_Chart___default.a,
    Readouts: __WEBPACK_IMPORTED_MODULE_4__components_Readouts___default.a,
    LeafletMap: __WEBPACK_IMPORTED_MODULE_5__components_LeafletMap___default.a
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('configureConnectionFromParams').then(function () {
      _this.$store.dispatch('fetchInfo');
    });
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartist__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapGetters */])({
    series: 'chartSeries'
  })),

  watch: {
    series: function series() {
      this.chart = new __WEBPACK_IMPORTED_MODULE_2_chartist___default.a.Line(this.$el, {
        series: [this.series.speed, this.series.elevation]
      }, {
        showPoint: false,
        showLine: true,
        showArea: false,
        fullWidth: true,
        showLabel: false,
        axisX: {
          showGrid: true,
          labelInterpolationFnc: function labelInterpolationFnc(v, i) {
            return i % 60 === 0 ? i : null;
          },
          showLabel: true,
          offset: 0
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0
        },
        chartPadding: { left: 0, right: 0, top: 5, bottom: 5 },
        low: 0
      });
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Slider__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Slider__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_2__components_Slider___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapGetters */])(['currentPercent'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapActions */])({
    setPercent: 'percentToTrackIdx'
  }), {
    onSliderUpdate: function onSliderUpdate(value) {
      this.setPercent(value);
    }
  })
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_start_marker_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_start_marker_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_start_marker_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_finish_marker_svg__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_finish_marker_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_finish_marker_svg__);


//
//
//
//
//
//
//
//
//
//
//
//
//









__webpack_require__(154);
__webpack_require__(171);
__webpack_require__(155);
__webpack_require__(172);

var trackerSVG = '\n<svg height="26" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 580 400">\n <g>\n  <path vector-effect="non-scaling-stroke" fill="#ff9e00" fill-opacity="0.8" stroke="#ffffff" stroke-width="1" d="m1.5,1.5l578.5,198.5l-580,200l130,-199l-128.5,-199.5z" id="svg_1"/>\n  <ellipse fill="#ffffff" cx="193" cy="200" id="svg_4" rx="22" ry="22"/>\n </g>\n</svg>\n';

function addViewModeSwitch(map) {
  var normalViewButton = void 0,
      centerViewButton = void 0,
      isCenter = void 0;

  var panTo = __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(function (latLng) {
    map.panTo(latLng);
  }, 2000, { trailing: true });

  /* eslint-disable no-undef */
  normalViewButton = L.easyButton('fa-expand', function () {
    isCenter = false;
    map.removeControl(normalViewButton);
    map.addControl(centerViewButton);
  }, 'Normal Mode', '');
  centerViewButton = L.easyButton('fa-dot-circle-o', function () {
    isCenter = true;
    map.removeControl(centerViewButton);
    map.addControl(normalViewButton);
  }, 'Center Mode', '');
  /* eslint-enable */

  map.addControl(centerViewButton);

  return function (point) {
    if (isCenter) {
      panTo(point);
    }
  };
}

/* harmony default export */ __webpack_exports__["default"] = ({

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    url: function url(state) {
      return state.track.url;
    },
    color: function color(state) {
      return state.track.color;
    },
    points: function points(state) {
      return state.track.points;
    },
    currentIdx: function currentIdx(state) {
      return state.track.current_idx;
    }
  })),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])({
    setIdx: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["j" /* SET_TRACK_CURRENT_IDX */]
  })),

  watch: {
    url: function url() {
      this.$store.dispatch('fetchGraph');
    },
    points: function points() {
      var _this = this;

      var polyline = new __WEBPACK_IMPORTED_MODULE_4_leaflet__["Polyline"](this.points, {
        color: this.color
      });
      polyline.addTo(this.map);
      this.map.fitBounds(polyline.getBounds());
      var start = new __WEBPACK_IMPORTED_MODULE_4_leaflet__["Marker"](this.points[0], {
        icon: new __WEBPACK_IMPORTED_MODULE_4_leaflet__["Icon"]({
          iconUrl: __WEBPACK_IMPORTED_MODULE_6__assets_start_marker_svg___default.a,
          className: 'start-marker',
          iconSize: [28, 40],
          iconAnchor: [14, 39]
        })
      });
      start.on('click', function () {
        _this.setIdx({ idx: 0 });
      });
      start.addTo(this.map);
      var end = new __WEBPACK_IMPORTED_MODULE_4_leaflet__["Marker"](this.points[this.points.length - 1], {
        icon: new __WEBPACK_IMPORTED_MODULE_4_leaflet__["Icon"]({
          iconUrl: __WEBPACK_IMPORTED_MODULE_7__assets_finish_marker_svg___default.a,
          className: 'finish-marker',
          iconSize: [28, 40],
          iconAnchor: [14, 39]
        })
      });
      end.on('click', function () {
        _this.setIdx({ idx: _this.points.length - 1 });
      });
      end.addTo(this.map);

      this.tracker = new __WEBPACK_IMPORTED_MODULE_4_leaflet__["Marker"](this.points[0], {
        rotationAngle: 90,
        icon: new __WEBPACK_IMPORTED_MODULE_4_leaflet__["Icon"]({
          iconUrl: 'data:image/svg+xml;base64,' + btoa(trackerSVG),
          className: 'tracker',
          iconSize: [38, 26],
          iconAnchor: [9, 13]
        })
      });
      this.tracker.addTo(this.map);

      polyline.on('click', function (evt) {
        var latLng = evt.latlng;
        var distances = _this.points.map(function (el) {
          return latLng.distanceTo(new __WEBPACK_IMPORTED_MODULE_4_leaflet__["LatLng"](el.lat, el.lng));
        });
        var idx = distances.indexOf(Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(distances)));
        _this.setIdx({ idx: idx });
      });
    },
    currentIdx: function currentIdx() {
      var point = this.points[this.currentIdx];
      this.tracker.setLatLng(point);
      var angle = point.c && point.c[0];
      if (angle !== void 0) {
        this.tracker.setRotationAngle(90 + angle);
      }
      this.updateView(point);
    }
  },

  mounted: function mounted() {
    this.map = new __WEBPACK_IMPORTED_MODULE_4_leaflet__["Map"](this.$el, { preferCanvas: true });
    new __WEBPACK_IMPORTED_MODULE_4_leaflet__["TileLayer"]('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);
    this.map.setView([48.7670, 9.1761], 14);
    this.updateView = addViewModeSwitch(this.map);
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.user;
    },
    vehicle: function vehicle(state) {
      return state.vehicle;
    }
  }))
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      units: {
        km: { speed: 'KM/H', elevation: 'M', distance: 'km' },
        mi: { speed: 'MPH', elevation: 'FT', distance: 'mi' }
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    unit: function unit(state) {
      return state.unit;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapGetters */])({
    readout: 'currentReadout'
  }))
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };
  el.addEventListener(event, once, false);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: { type: Number, default: 0 }
  },

  data: function data() {
    return {
      app: {},
      isActive: false,
      left: 0
    };
  },


  watch: {
    value: function value() {
      if (!this.isActive) {
        this.left = this.value;
      }
    }
  },

  methods: {
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;
      this.app.style.userSelect = 'none';

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        addOnceEventListener(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        addOnceEventListener(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.style.userSelect = 'auto';
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _slider$getBoundingCl = this.slider.getBoundingClientRect(),
          offsetLeft = _slider$getBoundingCl.left,
          trackWidth = _slider$getBoundingCl.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;
      left = left < 0 ? 0 : left > 100 ? 100 : left;
      this.left = left;
      this.$emit('update', left);
    }
  },

  mounted: function mounted() {
    // dragging is attached to root element so it isn't restricted only to slider area
    this.app = this.$root.$el;
    this.slider = this.$el;
    this.left = this.value;
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_device__ = __webpack_require__(90);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var APIs = {
  w3: {
    enabled: 'fullscreenEnabled',
    element: 'fullscreenElement',
    request: 'requestFullscreen',
    exit: 'exitFullscreen',
    onchange: 'fullscreenchange',
    onerror: 'fullscreenerror'
  },
  newWebkit: {
    enabled: 'webkitFullscreenEnabled',
    element: 'webkitFullscreenElement',
    request: 'webkitRequestFullscreen',
    exit: 'webkitExitFullscreen',
    onchange: 'webkitfullscreenchange',
    onerror: 'webkitfullscreenerror'
  },
  oldWebkit: {
    enabled: 'webkitIsFullScreen',
    element: 'webkitCurrentFullScreenElement',
    request: 'webkitRequestFullScreen',
    exit: 'webkitCancelFullScreen',
    onchange: 'webkitfullscreenchange',
    onerror: 'webkitfullscreenerror'
  },
  moz: {
    enabled: 'mozFullScreen',
    element: 'mozFullScreenElement',
    request: 'mozRequestFullScreen',
    exit: 'mozCancelFullScreen',
    onchange: 'mozfullscreenchange',
    onerror: 'mozfullscreenerror'
  },
  ios: {
    enabled: 'webkitFullscreenEnabled',
    element: 'webkitFullscreenElement',
    request: 'webkitEnterFullscreen',
    exit: 'webkitExitFullscreen',
    onchange: 'webkitfullscreenchange',
    onerror: 'webkitfullscreenerror'
  },
  ms: {
    enabled: 'msFullscreenEnabled',
    element: 'msFullscreenElement',
    request: 'msRequestFullscreen',
    exit: 'msExitFullscreen',
    onchange: 'MSFullscreenChange',
    onerror: 'MSFullscreenError'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['video'],

  data: function data() {
    return {
      fullscreen: false
    };
  },


  methods: {
    isFullscreen: function isFullscreen() {
      return document[this.api.element] != null || this.video.webkitDisplayingFullscreen;
    },
    toggle: function toggle() {
      if (this.isFullscreen()) {
        this.video[this.api.exit]();
      } else {
        this.video[this.api.request]();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    for (var browser in APIs) {
      if (APIs[browser].enabled in document) {
        this.api = APIs[browser];
        break;
      }
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_device__["a" /* isIOSDevice */])()) {
      // Override APIs on iOS
      this.api = APIs.ios;
    }
    document.addEventListener(this.api.onchange, function (evt) {
      _this.fullscreen = _this.isFullscreen();
    });
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['video'],

  data: function data() {
    return {
      isPlaying: false
    };
  },


  watch: {
    video: function video() {
      var _this = this;

      this.video.addEventListener('play', function () {
        _this.isPlaying = true;
      });
      this.video.addEventListener('pause', function () {
        _this.isPlaying = false;
      });
    }
  },

  methods: {
    togglePlay: function togglePlay() {
      this.video.paused ? this.video.play() : this.video.pause();
    }
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FullscreenControl__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FullscreenControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FullscreenControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OverlayPlay__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OverlayPlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OverlayPlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TimelineSlider__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TimelineSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TimelineSlider__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FullscreenControl: __WEBPACK_IMPORTED_MODULE_3__FullscreenControl___default.a,
    OverlayPlay: __WEBPACK_IMPORTED_MODULE_4__OverlayPlay___default.a,
    TimelineSlider: __WEBPACK_IMPORTED_MODULE_5__TimelineSlider___default.a
  },

  data: function data() {
    return {
      video: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    url: function url(state) {
      return state.video.url;
    },
    seekTime: function seekTime(state) {
      return state.video.seek_time;
    },
    currentTime: function currentTime(state) {
      return state.video.current_time;
    }
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])({
    updateTime: __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["f" /* VIDEO_TIME_UPDATE */]
  })),

  watch: {
    seekTime: function seekTime() {
      this.video.currentTime = this.seekTime;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.video = this.$el.children[0];
    this.video.addEventListener('timeupdate', function () {
      var seconds = _this.video.currentTime;
      if (seconds !== _this.currentTime && seconds !== _this.seekTime) {
        _this.updateTime(seconds);
      }
    });
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Slider__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ms_to_time__ = __webpack_require__(91);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_0__components_Slider___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__utils_ms_to_time__["a" /* default */]],

  props: ['video'],

  data: function data() {
    return {
      duration: 0,
      currentTime: 0
    };
  },


  computed: {
    timeLeft: function timeLeft() {
      return this.duration - this.currentTime;
    },
    position: function position() {
      return 100 / this.duration * this.currentTime || 0;
    }
  },

  watch: {
    video: function video() {
      var _this = this;

      this.video.addEventListener('timeupdate', function () {
        _this.currentTime = _this.video.currentTime;
      });
      this.video.addEventListener('durationchange', function () {
        _this.duration = _this.video.duration;
      });
    }
  },

  methods: {
    onSliderUpdate: function onSliderUpdate(value) {
      this.video.currentTime = this.video.duration * (value / 100);
    }
  }
});

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1Ni4xIDgwIj4KICA8cGF0aAogICAgZmlsbD0iI0ZGMkIwMCIKICAgIGQ9Ik0yOC4xIDFDMTMuMSAxIDEgMTMuMSAxIDI4LjFjMCAyMC4zIDI3LjEgNTAuNCAyNy4xIDUwLjRzMjcuMS0zMCAyNy4xLTUwLjRDNTUuMSAxMy4xIDQzIDEgMjguMSAxIgogIC8+CiAgPHBhdGgKICAgIGZpbGw9Im5vbmUiCiAgICBzdHJva2U9IiNGRkYiCiAgICBzdHJva2VXaWR0aD0iMiIKICAgIHN0cm9rZU1pdGVybGltaXQ9IjEwIgogICAgZD0iTTI4LjEgMUMxMy4xIDEgMSAxMy4xIDEgMjguMWMwIDIwLjMgMjcuMSA1MC40IDI3LjEgNTAuNHMyNy4xLTMwIDI3LjEtNTAuNEM1NS4xIDEzLjEgNDMgMSAyOC4xIDF6IgogIC8+CiAgPHBhdGgKICAgIGZpbGw9IiNGRkYiCiAgICBkPSJNMTkuMiA0NS41Yy0uOCAwLTEuNS0uNy0xLjUtMS41VjE3LjljMC0uOC43LTEuNSAxLjUtMS41czEuNS43IDEuNSAxLjV2MjYuMmMtLjEuOC0uNyAxLjQtMS41IDEuNE0yMy42IDE4LjRWMjloMThWMTcuNGgtMTh6IgogIC8+CiAgPHBhdGgKICAgIGZpbGw9Im5vbmUiCiAgICBzdHJva2U9IiNGRkYiCiAgICBzdHJva2VXaWR0aD0iMiIKICAgIGQ9Ik0yMy42IDE4LjRWMjloMThWMTcuNGgtMTh6IgogIC8+CiAgPHBhdGgKICAgIGZpbGw9IiNGRjJCMDAiCiAgICBkPSJNMjQuNiAyNC44aDMuMlYyOGgtMy4yek0yNC42IDE4LjRoMy4ydjMuMmgtMy4yek0yNy44IDIxLjZIMzF2My4yaC0zLjJ6TTMxIDI0LjhoMy4yVjI4SDMxek0zMSAxOC40aDMuMnYzLjJIMzF6TTM0LjIgMjEuNmgzLjJ2My4yaC0zLjJ6TTM3LjQgMjQuOGgzLjJWMjhoLTMuMnpNMzcuNCAxOC40aDMuMnYzLjJoLTMuMnoiCiAgLz4KPC9zdmc+Cg=="

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1Ni4xIDgwIj4KICA8cGF0aAogICAgZmlsbD0iIzQwRDQwMCIKICAgIGQ9Ik0yOC4xIDFDMTMuMSAxIDEgMTMuMSAxIDI4LjFjMCAyMC4zIDI3LjEgNTAuNCAyNy4xIDUwLjRzMjcuMS0zMCAyNy4xLTUwLjRDNTUuMSAxMy4xIDQzIDEgMjguMSAxIgogIC8+CiAgPHBhdGgKICAgIGZpbGw9Im5vbmUiCiAgICBzdHJva2U9IiNGRkYiCiAgICBzdHJva2VXaWR0aD0iMiIKICAgIHN0cm9rZU1pdGVybGltaXQ9IjEwIgogICAgZD0iTTI4LjEgMUMxMy4xIDEgMSAxMy4xIDEgMjguMWMwIDIwLjMgMjcuMSA1MC40IDI3LjEgNTAuNHMyNy4xLTMwIDI3LjEtNTAuNEM1NS4xIDEzLjEgNDMgMSAyOC4xIDF6IgogIC8+CiAgPHBhdGgKICAgIGZpbGw9IiNGRkYiCiAgICBkPSJNMzMuNSAxNi40djE2LjdsLTIwLTguNHpNMzYuOSA0NS41Yy44IDAgMS41LS43IDEuNS0xLjVWMTcuOWMwLS44LS43LTEuNS0xLjUtMS41cy0xLjUuNy0xLjUgMS41djI2LjJjLjEuOC43IDEuNCAxLjUgMS40IgogIC8+Cjwvc3ZnPgo="

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(162)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(201),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(198),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(204),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(199),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(202),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(205),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(196),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(203),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(156)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(195),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-timeline-slider"
  }, [_c('slider', {
    attrs: {
      "value": _vm.position
    },
    on: {
      "update": _vm.onSliderUpdate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "time-readout"
  }, [_vm._v(_vm._s(_vm.msToTime(_vm.currentTime * 1000)))]), _vm._v(" "), _c('div', {
    staticClass: "time-readout right"
  }, [_vm._v(" - " + _vm._s(_vm.msToTime(_vm.timeLeft * 1000)))])], 1)
},staticRenderFns: []}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player-overlay-play",
    on: {
      "click": _vm.togglePlay
    }
  }, [(!_vm.isPlaying) ? _c('i', {
    staticClass: "fa fa-play",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider",
    class: {
      active: _vm.isActive
    },
    on: {
      "mousedown": _vm.sliderMove
    }
  }, [_c('div', {
    staticClass: "thumb-container",
    style: ({
      left: _vm.left + '%'
    }),
    on: {
      "touchstart": _vm.onMouseDown,
      "mousedown": _vm.onMouseDown
    }
  }, [_c('div', {
    staticClass: "thumb"
  })])])
},staticRenderFns: []}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-guide"
  }, [_c('slider', {
    attrs: {
      "value": _vm.currentPercent
    },
    on: {
      "update": _vm.onSliderUpdate
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-overview"
  }, [(_vm.user.avatar) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.user.avatar
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.user.avatar) ? _c('i', {
    staticClass: "avatar fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vehicle.avatar) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.vehicle.avatar
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.vehicle.avatar) ? _c('i', {
    staticClass: "avatar fa fa-motorcycle",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n    " + _vm._s(_vm.user.name) + " "), _c('br'), _vm._v("\n    " + _vm._s(_vm.vehicle.name) + "\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('br'), _vm._v("\n    " + _vm._s(_vm.vehicle.brand) + " " + _vm._s(_vm.vehicle.model) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('profile-overview'), _vm._v(" "), _c('player'), _vm._v(" "), _c('readouts'), _vm._v(" "), _c('div', {
    staticClass: "chart-wrap"
  }, [_c('chart-guide'), _vm._v(" "), _c('chart')], 1), _vm._v(" "), _c('leaflet-map')], 1)
},staticRenderFns: []}

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart"
  })
},staticRenderFns: []}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "readouts"
  }, [_c('p', {
    staticClass: "speed"
  }, [_vm._v("\n    " + _vm._s(_vm.unit === 'mi' ?
    Math.round(_vm.readout.speed * 0.621371) || 0 :
    _vm.readout.speed) + "\n    "), _c('small', [_vm._v(_vm._s(_vm.units[_vm.unit].speed))])]), _vm._v(" "), _c('p', {
    staticClass: "elevation"
  }, [_vm._v("\n    " + _vm._s(_vm.unit === 'mi' ?
    Math.round(_vm.readout.elevation * 3.2808399) || 0 :
    _vm.readout.elevation) + "\n    "), _c('small', [_vm._v(_vm._s(_vm.units[_vm.unit].elevation) + " ")])]), _vm._v(" "), _c('p', {
    staticClass: "distance"
  }, [_vm._v("\n    " + _vm._s(_vm.readout.distance &&
    (
      (_vm.readout.distance / 1000) *
      (_vm.unit === 'mi' ? 0.621371 : 1)
    ).toLocaleString(undefined, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    })) + "\n    " + _vm._s(_vm.units[_vm.unit].distance) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player"
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }, [(_vm.url) ? _c('source', {
    attrs: {
      "src": _vm.url,
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('fullscreen-control', {
    attrs: {
      "video": _vm.video
    }
  }), _vm._v(" "), _c('overlay-play', {
    attrs: {
      "video": _vm.video
    }
  }), _vm._v(" "), _c('timeline-slider', {
    attrs: {
      "video": _vm.video
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leaflet-map"
  })
},staticRenderFns: []}

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "player-fullscreen-control",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.fullscreen ? 'fa-compress' : 'fa-expand'],
    attrs: {
      "aria-hidden": "true"
    }
  })])
},staticRenderFns: []}

/***/ })
],[83]);


// WEBPACK FOOTER //
// static/js/app.53cb1ca0781d622eff11.js